module.exports = __webpack_public_path__ + "Server-Unhealthy.AzureWebApp.8973e94f5c3d3f48c516d7faab70f5bd.hashedasset.svg";